import SEO from '../components/common/SEO'
import ServicesGlobalTrading from '../components/services/ServicesGlobalTrading'
import ServicesGrid from '../components/services/ServicesGrid'
import ServicesIndustries from '../components/services/ServicesIndustries'
import ServicesPageCta from '../components/services/ServicesPageCta'
import ServicesPageHero from '../components/services/ServicesPageHero'
import ServicesProcess from '../components/services/ServicesProcess'
import ServicesStrengths from '../components/services/ServicesStrengths'
import ServicesWhyChoose from '../components/services/ServicesWhyChoose'

function Services() {
  return (
    <>
      <SEO
        title="Services"
        description="Torbit Metals offers international metal trading, global sourcing, supply chain management, import-export, logistics, quality assurance and vendor management for non-ferrous metals worldwide."
      />
      <ServicesPageHero />
      <ServicesGrid />
      <ServicesGlobalTrading />
      <ServicesProcess />
      <ServicesWhyChoose />
      <ServicesStrengths />
      <ServicesIndustries />
      <ServicesPageCta />
    </>
  )
}

export default Services
